import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { bibliography } from 'src/app/core/translations/bibliography';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-bibliography',
  templateUrl: './bibliography.component.html',
  styleUrls: ['./bibliography.component.scss'],
})
export class BibliographyComponent implements OnInit {
  isHandsetPortrait: boolean = false;
  bannerImage: any ='';
  bannerClass: any ='';
  
  currentLanguage: string = '';
  languageTranslations: any = bibliography;
  activeLanguageTranslations: any = {};
  activeLanguageTranslationsEN: any = {};
  activeLanguageTranslationsPA: any = {};
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {

    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;
    
    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {
        this.activeLanguageTranslations = this.languageTranslations[language];
        this.activeLanguageTranslationsPA= this.languageTranslations['panjabi'];
        this.activeLanguageTranslationsEN = this.languageTranslations['english'];
      }
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
}
